import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ReferralPartnerType } from '/@/modules/estate/enums/ReferralPartnerType';

export class EstateHubspotDeal extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {string}
   */
  dealId;

  /**
   * @var {string}
   */
  clientFirstName;

  /**
   * @var {string}
   */
  clientLastName;

  /**
   * @var {boolean}
   */
  clientLanguagePreference;

  /**
   * @var {?string}
   */
  referralPartner;

  /**
   * @var {boolean}
   */
  isHighImpactContact;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.dealId = model.dealId;
    this.clientFirstName = model.clientFirstName;
    this.clientLastName = model.clientLastName;
    this.clientLanguagePreference = model.clientLanguagePreference;
    this.referralPartner = model.referralPartner;
    this.isHighImpactContact = model.isHighImpactContact;
  }

  get isVIP() {
    return this.isHighImpactContact;
  }
}
